export const sanitizeKey = (key: string) => {
    let s = key;
    s = s.replaceAll("_", " ");
    s = s.charAt(0).toUpperCase() + s.slice(1);
    return s;
}